import styled from "styled-components";
import {MATERIALS_IMAGE} from "../../helper/materials";
import {ConfigurateurContext} from "../../context/context";
import {getClassNameFromMid} from "../../helper/function";
import {device} from "../../helper/constants";

const {
    element: {
        useContext,
    },
} = wp;

const getImageFromMid = mid => {
    return MATERIALS_IMAGE[mid]['image'];
}
const getNameFromMid = mid => {
    return MATERIALS_IMAGE[mid]['label'];
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    width: 19%;
    
    & label {
        width: 100%;
    }
    & .label {
        margin-top: 5px;
        font-size: 13px;
        font-weight: 600;
    }
    & input[type=radio] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }
    & input[type=radio] + .radio-image {
        cursor: pointer;          
    }
    & input[type=radio]:checked + .radio-image {
        border: 3px solid #144344;
        border-radius: 12px;
    }

    @media ${device.mobile} {
        width: 30%;
      
    }
`;
const ImageContainer = styled.div`
    border-radius: 8px;
    border: 1px solid #DBDBDB;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  
    & img {
      max-height: 40px;
      border-radius: 0 !important;
    }
    & img.dcf-bpmv  {
        max-height: 60px !important;
    }
  
    & .label {
      text-align: center;
    }
`;
export default function DecoupeFormItem({formData, handleSelect}) {

    const {setForm, form} = useContext(ConfigurateurContext);

    const handleClick = () => {
        setForm(formData.fid);
        setTimeout(() => handleSelect(), 300);
    }
    return(
        <Wrapper>
            <label>
                <input type="radio" name="form-decoupe" value={formData.fid} checked={formData.fid === form} />
                <ImageContainer onClick={handleClick} className="radio-image">
                    <img src={formData.image} alt={formData.label}  className={getClassNameFromMid(formData.fid)} />
                    <span className="label">{formData.label}</span>
                </ImageContainer>
            </label>

        </Wrapper>
    );
}